<template>
    <div class="activity-box d-flex align-items-center">
        <div :class="'activity-info d-flex justify-content-between  align-items-center ' + [isEnable ? 'checked' : '']">
            <div :class="'d-flex align-items-center ' + [isDisable == 1 ? 'disabled' : '']">
                <input type="checkbox" :id="'act-' + source" :checked="isEnable" :disabled="isDisable == 1" name="activity"  @change="toggleActivity" />
                <label :for="'act-' + source" class="act-label">{{activityName}}</label>
            </div>
            <div v-show="isEnable">
                <div class="d-flex align-items-center">
                    <label v-if="hasSwitch" class="switch">
                        <input type="checkbox" :checked="activityLastLetter == 'S'" @change="switchActivity">
                        <div class="slider round">
                            <span class="on">{{switchOnLabel}}</span>
                            <span class="off">{{switchOffLabel}}</span>
                        </div>
                    </label>
                    <div :class="[isDisable == 1 ? 'disabled' : '']">
                        <div class="discount-status" v-if="activity.discount_status == 'Free Loyalty' || activity.discount_status == 'Free WTF'">
                            <div class="status" v-if="activity.discount_status == 'Free Loyalty'">F</div>
                            <div class="status orange" v-else>C</div>
                        </div>
                        <select @change="fireUpdated" v-model="activity.status" :disabled="isDisable == 1" v-select2 class="select">
                            <option value="OK">OK</option>
                            <option value="DNX">DNX</option>
                            <option value="WTF">WTF</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="activity-status">
            <span :class="'status ' + checkStatus"></span>
            <b v-if="activity1 && activity1.group_number">{{pad(activity1.group_number)}}</b>
            <b v-else-if="checkStatus == 'not-assigned'" class="no-group">??</b>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activity : this.activity1 || this.activity2 || {status: "OK", activity: this.switchOffLabel},
            isEnable : (this.activity1 || this.activity2) ? true : false,
            isUpdated : false
        }
    },
    props: [
        'activity1', 
        'activity2',
        'activityName',
        'switchOnLabel',
        'switchOffLabel',
        'hasSwitch',
        'source',
        'parent'
    ],
    computed: {
        checkStatus() {
            if (!this.activity1 && !this.activity2) {
                return 'not-doing';
            }

            if(this.activity1) {
                if(!this.activity1.parent) {
                    if ((this.activity1.activity == 'SW' || this.activity1.activity == 'TC') && !this.activity1.group_number) {
                        return 'not-assigned';
                    }

                    if (this.activity1.is_uploading == 0) {
                        return 'waiting';
                    }

                    if (this.activity1.is_uploading == 1 && this.activity1.notification_sent == 0) {
                        return 'processing';
                    }

                    if (this.activity1.is_uploading == 1 && this.activity1.notification_sent == 1) {
                        return 'uploaded';
                    }
                } else {
                    if ((this.activity1.parent.activity == 'SW' || this.activity1.parent.activity == 'TC') && !this.activity1.parent.group_number) {
                        return 'not-assigned';
                    }

                    if (this.activity1.parent.is_uploading == 0) {
                        return 'waiting';
                    }

                    if (this.activity1.parent.is_uploading == 1 && this.activity1.parent.notification_sent == 0) {
                        return 'processing';
                    }

                    if (this.activity1.parent.is_uploading == 1 && this.activity1.parent.notification_sent == 1) {
                        return 'uploaded';
                    }
                }
                
            }

            if(this.activity2) {
                if ((this.activity2.activity == 'SW' || this.activity2.activity == 'TC') && !this.activity2.group_number) {
                    return 'not-assigned';
                }

                if (this.activity2.is_uploading == 0) {
                    return 'waiting';
                }

                if (this.activity2.is_uploading == 1 && this.activity2.notification_sent == 0) {
                    return 'processing';
                }

                if (this.activity2.is_uploading == 1 && this.activity2.notification_sent == 1) {
                    return 'uploaded';
                }
            }
        },
        activityLastLetter() {
            if(!this.activity.activity) {
                return;
            }

            return this.activity.activity.substring(2,3);
        },
        isDisable() {
            if(this.activity1 && (this.activity1.activity == 'SW' || this.activity1.activity == 'TC')) {
                if(!this.activity1.parent) {
                    return this.activity1.is_locked;
                } else {
                    return this.activity1.parent.is_locked;
                }
            } else {
                return this.activity.is_locked;
            }
        }  
    },
    methods: {
        toggleActivity() {
            this.isEnable = !this.isEnable;
            this.fireUpdated();
        },
        switchActivity() {
            this.activity.activity = (this.activity.activity == this.switchOnLabel) 
                ? this.switchOffLabel
                : this.switchOnLabel;

            this.fireUpdated();
        },
        fireUpdated() {
            this.isUpdated = true;
            this.$emit('activityHasUpdated', {
                source : this.source,
                activity : this.activity,
                isEnable : this.isEnable,
                isUpdated : this.isUpdated
            });
        },
        pad(n) {
            return (n < 10) ? ("0" + n) : n;
        },
    },
    mounted() {
        $("select.select").select2({
            minimumResultsForSearch: Infinity,
            width: '81px',
        });
    }
}
</script>